// extracted by mini-css-extract-plugin
export default {"status":"ApprovalStatus_status__z2S6D","status_approved":"ApprovalStatus_status_approved__8jST4","status_rejected":"ApprovalStatus_status_rejected__gzn0k"};